import { makeStyles } from '@material-ui/core/styles';

/**
 * Shared styling for the supply screens.
 *
 * react-admin renders `aside` after the list content, so `row-reverse` on the
 * List/Show root is what puts the search / detail card on the left, matching
 * the rest of the supply module.
 */
const useSupplyStyles = makeStyles(theme => ({
    asideLeft: {
        flexDirection: 'row-reverse',
    },
    asideCard: {
        width: 260,
        minWidth: 260,
        marginRight: '1em',
        marginTop: '1em',
        alignSelf: 'flex-start',
    },
    asideCardWide: {
        marginTop: '1em',
    },
    /**
     * Horizontal summary strip at the top of a results list — the row of
     * label/value pairs that used to sit in a left-hand aside card.
     */
    headerStrip: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        padding: theme.spacing(1.5, 2),
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    headerFact: {
        marginRight: theme.spacing(5),
        minWidth: 120,
    },
    headerValue: {
        fontSize: 14,
        fontWeight: 'bold',
        wordBreak: 'break-word',
    },
    asideTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#2b4a7d',
        marginBottom: '0.5em',
    },
    asideLabel: {
        fontSize: 12,
        color: '#666',
    },
    asideValue: {
        fontSize: 13,
        fontWeight: 'bold',
        marginBottom: '0.6em',
        wordBreak: 'break-word',
    },
    actionLink: {
        display: 'block',
        fontSize: 13,
        padding: '3px 0',
        cursor: 'pointer',
    },
    /** Actions that change stock — Adjustment, Apply Hold, Release Hold. */
    actionButton: {
        marginBottom: theme.spacing(1),
        justifyContent: 'flex-start',
    },
    actionDivider: {
        margin: theme.spacing(1.5, 0),
    },
    /**
     * Navigation away from this lot — Adjustment History, All Lots. Tinted
     * rather than plain text so they read as destinations worth clicking,
     * but lighter than the solid action buttons above them.
     */
    navButton: {
        marginBottom: theme.spacing(1),
        justifyContent: 'flex-start',
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.primary.main,
        fontWeight: 600,
        '& .MuiButton-endIcon': {
            marginLeft: 'auto',
        },
        '&:hover': {
            backgroundColor: theme.palette.action.selected,
        },
    },
    sectionTitle: {
        fontSize: 15,
        fontWeight: 'bold',
        color: '#2b4a7d',
        textTransform: 'uppercase',
        margin: '0.8em 0 0.4em 0',
    },
    tableHead: {
        backgroundColor: '#2b6cb0',
    },
    tableHeadCell: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: 12,
    },
    expiring: {
        backgroundColor: '#fff6e0',
    },
    expired: {
        backgroundColor: '#ffe8e8',
    },
    positive: {
        color: '#1a7f37',
    },
    negative: {
        color: '#b42318',
    },
    searchButton: {
        marginTop: '1em',
    },
}));

export default useSupplyStyles;
